
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/e7605311edff4188dbd664db0f9809d3/1fe3c15d92ab9435ca4f4ef1ff5159ff.png"
            alt="Ukrainian veteran and family member sitting together at dusk"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center text-white">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-medium leading-tight mb-8">
            {t('hero_headline')}
          </h1>
          <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-12 max-w-3xl mx-auto">
            {t('hero_subtext')}
          </p>
          <Link
            to="/contact"
            className="inline-block bg-white text-stone-800 px-12 py-4 rounded-full text-lg font-medium hover:bg-amber-500 hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            {t('hero_cta')}
          </Link>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="py-20 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-medium text-stone-800 text-center mb-20">
            {t('what_we_do_title')}
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
            {/* Outreach & Visits */}
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-500/10 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-heart-line text-2xl text-stone-700"></i>
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-4">
                {t('outreach_title')}
              </h3>
              <p className="text-stone-600 leading-relaxed mb-6">
                {t('outreach_desc')}
              </p>
              <Link
                to="/outreach"
                className="text-amber-600 hover:text-amber-700 text-sm font-medium transition-colors duration-200 group"
              >
                {t('learn_more')} 
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* PTSD Education */}
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-500/10 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className="ri-brain-line text-2xl text-stone-700"></i>
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-4">
                {t('ptsd_education_title')}
              </h3>
              <p className="text-stone-600 leading-relaxed mb-6">
                {t('ptsd_education_desc')}
              </p>
              <Link
                to="/ptsd-education"
                className="text-amber-600 hover:text-amber-700 text-sm font-medium transition-colors duration-200 group"
              >
                {t('learn_more')} 
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>

            {/* Third-Location Decompression */}
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-500/10 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className="ri-compass-3-line text-2xl text-stone-700"></i>
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-4">
                {t('tld_title')}
              </h3>
              <p className="text-stone-600 leading-relaxed mb-6">
                {t('tld_desc')}
              </p>
              <Link
                to="/tld"
                className="text-amber-600 hover:text-amber-700 text-sm font-medium transition-colors duration-200 group"
              >
                {t('learn_more')} 
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Shared Voices Section */}
      <section className="bg-stone-50 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-xs uppercase tracking-wider text-stone-500 mb-4">
            {t('testimonials_label')}
          </div>
          <h2 className="text-3xl font-medium text-stone-800 mb-6 leading-tight">
            {t('shared_voices_title')}
          </h2>
          <p className="text-lg text-stone-600 leading-relaxed italic">
            {t('shared_voices_text')}
          </p>
          <div className="w-32 h-px bg-stone-300 mx-auto mt-8"></div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
